import React, { Component } from "react";
import "./paymentFormCreditCard.css";
import { HttpService } from "../../../services/http/http-service";
import TermsAndCondition from "../../shared/termsAndCondition";
import {
  Modal,
  Spinner,
  Card,Alert,
  Form,
  InputGroup,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faMapSigns,
  faUser,
  faClock,
  faCreditCard, 
  faLocationArrow, 
} from "@fortawesome/free-solid-svg-icons";
import ProgressLoader from "../../shared/progress-loading/progress-loader";

class CreditCardForm extends Component {
  constructor(props) {
    super(props);
    let date = new Date();
    let dateYear = date.getFullYear();
    let month = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let months = [];
    let monthIntail = 0;
    for (monthIntail = 0; monthIntail < month.length; monthIntail++) {
      let getMonthNumber = (monthIntail + 1).toString();
      if (parseInt(getMonthNumber) < 10) {
        getMonthNumber = "0" + getMonthNumber;
      }
      months.push({ code: getMonthNumber, name: month[monthIntail] });
    }

    let dateYear25 = dateYear + 25;
    let years = [];
    while (dateYear < dateYear25) {
      years.push(dateYear);
      dateYear++;
    }
    this.state = {
      showModal: false,
      validated: false,
      agreeTermsCommand: false,
      isFormValid: true,
      agreeTermsCredit: false,
      isLoaded: false,
      ipInformation: { ip: "", country: "", city: "" },
      isIpInformationLoaded: false,
      isCreditCard: true,
      initLocalPayment: {},
      FloCashPaymentOptions: [],
      CellPointPaymentOptions: [],
      isLoadingPaymentCredit: false,
      PaymentResponseMessage: null,
      FirstName: "",
      LastName: "",
      CardType: "",
      CardNumber: "",
      CVC: "",
      ExpireMonth: "",
      Months: months,
      Years: years,
      PostalCode: "",
      ResidenceCountry: "",
      ExpireYear: "",
      AddressTwo: "",
      BillingAddress: "",
    };
  }

  async componentDidMount() {
    // this.getIpaddress(0);

    const publicIp = require('public-ip');
    localStorage.removeItem("paymentType");
    (async () => { 
      // console.log(await publicIp.v4());
      // console.log(await publicIp.v6());
       var IpData= await publicIp.v4() 
       this.getIpaddress(0,IpData);
      
    })();


  }

  getIpaddress(optionType,IpData) {
    let paymentInfoId = optionType;
    let ipInformationRelativePath =
      "/json/?key=185f0fbd5ca1368bc0a0edc31057ad1b944311b9";

    this.setState({ isIpInformationLoaded: false });
    HttpService.getIPService(IpData)
    .then(
      (response) => {
      // console.log("response");
      // console.log(response);
        this.setState({
          ipInformation: response.data,
          isIpInformationLoaded: true,
        });
        // this.__PaymentFormValidatorService.intializeFormValidation();
      },
      (error) => {
        // console.log("Can't connect to the getIpaddress service");
      }
    );
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      this.setState({ isFormValid : false });
      window.scrollTo({ top: 50, behavior: "smooth" });
      event.preventDefault();
      event.stopPropagation(); 
    } else {
      this.setState({ isFormValid : true });
      event.preventDefault();
      event.stopPropagation();
      this.submitPayment();
    }

    this.setState({ validated: true });
  };

  submitPayment() {
    

    this.setState({
      isLoadingPaymentCredit: true,
      PaymentResponseMessage: null,
    });
    let submitApiRelativePath = "/Payment/MakePayment";

    if (true) {
      var paymentInformationRequestObject = {
        cardNumber: null,
        cardCode: "VI",
        cardType: "CC",
        cvc: null,
        expireDate: null,
        cardHolder: {
          firstName: null,
          lastName: null,
        },
        addressLine1: null,
        addressLine2: null,
        cityName: null,
        postalCode: null,
        ipcountry: null,
        cardcountry: null,
        sessionId: null,
        ipAdress: null,
        PaymentMethod: "DIRECT",
      };

      paymentInformationRequestObject.cardHolder.firstName = this.state.FirstName;
      paymentInformationRequestObject.cardHolder.lastName = this.state.LastName;
      paymentInformationRequestObject.cardNumber = "" + this.state.CardNumber;
      paymentInformationRequestObject.cvc = "" + this.state.CVC;
      paymentInformationRequestObject.cardCode = this.state.CardType;
      paymentInformationRequestObject.expireDate =
        this.state.ExpireMonth + "/" + this.state.ExpireYear;
      paymentInformationRequestObject.addressLine1 = this.state.BillingAddress;
      if (this.state.AddressTwo == undefined || this.state.AddressTwo == "") {
        this.setState({ AddressTwo: null });
      }
      paymentInformationRequestObject.addressLine2 = this.state.AddressTwo;
      paymentInformationRequestObject.cardcountry = this.state.ResidenceCountry;
      //paymentInformationRequestObject.cityName = this.state.CityName;
      paymentInformationRequestObject.postalCode = this.state.PostalCode;
      //paymentInformationRequestObject.pnr = this._flightLocalStorageService.getFlightSummary().reloc;
      paymentInformationRequestObject.sessionId = localStorage.getItem(
        "sessionId"
      );
      paymentInformationRequestObject.ipAdress = this.state.ipInformation.ip;
      paymentInformationRequestObject.ipcountry = this.state.ipInformation.country;
      paymentInformationRequestObject.cityName = this.state.ipInformation.city;

      let paymentFormData = {
        ipcountry: this.state.ipInformation.country,
        ipAddress: this.state.ipInformation.ip,
      };
    //   var n=` 
    //   <!DOCTYPE html>
    //   <html><script>var timer = setInterval(function(){document.getElementById('3DSecureform').submit();if(timer){clearInterval(timer)};}, 1);</script><body><form method=\"POST\" action=\"https://checkoutshopper-test.adyen.com/checkoutshopper/threeDS2.shtml\" name=\"3DSecureform\" id=\"3DSecureform\" ><input type=\"hidden\" name=\"MD\" value=\"M2RzMi4wYWUzM2FhOWY1ZTM0ZmQxMTJhOGFiOWU4ZWIxMWU0ODQ3ZDA1ODQ1MTUwYWVjYTlkYTMyN2Q4Mjg3OWMzNTk4\" /><input type=\"hidden\" name=\"PaReq\" value=\"BQABAgAgQVLu3pdnlfWPT9SJD1Y-OQTy2b0l4nLAB1JKunYy1elajlNFoJ4ZoMX98Nevofec09KQ9OL2p84cCJZiONtLb8qs8GPdqU0yRxNrWB0Xwrk2IYyzOecbepE0eZoEcj6kMeWApbK6J-9RoeP-iOaDDVhXSX3NdiaHroVcpTJN1OqwL9XHhZ8uXLCGOyt_pVJOZDNjnLE9y9wExx5fBysUnOE0_S99ufPoDvBVecPZTG9pxlRc1QsprVvDGn4Ag_EVw4xz4I3mZijIskIz8VEFLdwi3lvqzJTvnCZVYDcPV0-cDs7HsRT1KVVpbKvGprtK9dEJlCXgy8uKh4RPioOHmA4qkUY0S_rP44wVHP1JqomJgkd_48hvt2ilOiwpDb0Gtv-4Gjqa6DtWXTV0AKznBxKYMJbfvU1eikH4iCxwv1SQD-fH-_YNt68UKrpVhppxdoX5u_5BJgWx7IgHcDuw_mtuD81KXvEyuFFqYp0Mode6kHMqvMzbMFIbKDGCYkUIZr-wk-zwYVIcMJ-8oYHgOHf4ZKkg5gu1BJbdCSRxm8AHzpE9tE21KfCqGqtrvj4gQbiAYpoTfHLDxhNvTzu_khA2BFZG9SBQ8aj4-ijA_iYZCUad-_cCaBeE_kZ1f0RtmqP2R7PBGSQlKu4SpopEjuQO7UmVu8Tfbp-sJ-ROgRBmVFoyQC7J43GIHFk9E_ojAEp7ImtleSI6IkFGMEFBQTEwM0NBNTM3RUFFRDg3QzI0REQ1MzkwOUI4MEE3OEE5MjNFMzgyM0Q2OERBQ0M5NEI5RkY4MzA1REMifeU7iVSjLg5amzALwRVSH7omUXFx7tYUHmTM65NhtCJHzhFvMFtnKfmeDLgi3oOH4Y-GPsTFOXIZjfxn_dgjCvxliTE_7S5PENUePM57oCtDOaXEC_PYLajj989nDUork4Ll8g-qtvwrFiNX9xippPMlo16Dm-t2OqQSvJA03PcUd2tCh3wT2RGiQBBkopJZcEkheP46qgZ97K375gnCM5-PMOVxJMsOS0vYQEtZ3ywqDKcRpXmEpOsGgzKk419izuDsAkltfqVpaOFMUpg3eSRXIbcz66vOWz7p9t746TFAamsBxFOIC4mO4sXQB24AJEG7vFSaBv0e5qw-pPEjeKuuCib35AHEopSyz9c8wziQs7qIkfHCTaZz5yKPXhQCHFA04JJ3kvJxcMiTnNCFRsNQUIvn2i4yLgUAAQEAKdBWeXHelQ3hZLtVptR-RZ5fJSbLbvdys0kH03fRF0krS1puo105gawuh_n7_98c2Gtpc3Vhe5Dxw9MkjsabSMgiW3c_rGtM_mc7K71dSwHekWd0yUCu4WLVRwwMA8myVN606frB8NrG4SS6S5M5O4xLl1cOLxrsQplWEch7PbNy-gTO6YwJePcP-WEdFHpqYw_mVyGHVH-E44olr8Y969lh0qpdyWljQlIi7cRBpcZ_VZUKcoj4YVIzkdDDnUAT_NkhNChEUX1emoXd9vcI_f-BArJ8BiO4xJBLD-KTF8QFmSc-RXm8ktgmUtgdIola9L5N0IQlJ-SHP_Pw6hpR4xCr4WVb0Ds5OKD7CVh9VeXJAABZ0Ugt-ak1BE_mnKHxxceBHSxUfjAutXpReeyy1-28bpPkMJ1ZcH0ddXKNArrl8zvYp-xrq1BSOb7iu2Eo7UQYG51zQIqaBETYsIEXNRqCHFfYM21sEsZQmDyYMdr9g4ZHkpDt8qhLALfyH2cQ6qDlZjdAyBXNnt4EoyDynrXUVE9op8I82s2qWr4XadF0tMhLelCDopFzRMr98awubHCddwvFBekKTYPcmnm2k1yPo_zLlCMtcJAAE1q0P7Utz8v0B6k-4s1uM31Urquzyb25AVABMBE80lkrmVUwA_O-1YeRnXM-oE8ED5ByBiWNpuwdU7cdSV9BHTYCyAaSYpnOpQ2ZbOXguA_jq0hVdSdctjYCgLwYVBUGvGOe5RD2jlwCu4U4HqOE_arNV17mz0AzeK-WDxFIWNRDcT5_phtlLHgdDVoQqXMBddNawtEZ-J8wIBki2sLYE6bgyknf9gyG3sQj0FjdxgDQM_DAAgKzXUxOqy_LtA4yFsY-_94tNpas-x8glZfe3lwiw9fEI0kqVjw2zOdJw1IOS_0UjgVHAEvERlLtwztx1FptCXxoxJl51_4hrOyz-NB17fN1KeFYJ8Hf-_B5AsH7LPYBlvel876Nlon1yoS1fKFraPrCg7UHJk_OCE8j1DX9MOX5zxc4j-MKI703T_PlGmxSmepNHy2hfjE4SVVET79lGhKnJ0J3UTLpiFw56uHh8R4V5C_guYP7E83BrXB6LAIKHO78V6X81xvB8Qj0mzbJ-Ztm-9hi9j6F3YJF1yLZ8vV9wcr1ORq-BW-tmrwd71Un-YEBHwnHarcjE7khoVs-KWCCCKFJe3kz3-xO8qrFt0c69nHGbNJTFKp2DlW4pUbU0zoLa_V2b6qoFBKVEUq7r0LznO_aeYoICxuutPmDLvKH7mD2sTVbcgGPuvm4idlSI44hr51j83t3G8hs4YEXilT9RHTPdfye39ctHUQlMO3YBDYqp4gKjdHgw7qCsy8-daDQUJ6X8jAnxuNAZo4xKGnNW9ZebHh4X0BZJpV_OsIspbi0wr2f4ar6YezkKq2_Q-6BGdcLjcEf1WX8lKDsiuhc_NN0OEHCjQb1actGE5ZPu5JqQFKr_yKyCykzrH1_8gyjaFQHJCU3oQsbP8oKYPvwJ5t1UkBdrZgCJmR0Jqv1x3QDyNxEmZSW9vQ4NcJcNX1BVeIdFi1Pibn2Q8ZTxzbVzhQV055W0GehGhlFCnTMxOBtH9fjaja53W97yWFNP1ZKR3j-KEMWoeo0t0I_eAXtAela0wu8G3_gxZwqZZorqGA_mS9Ivasz5Zp_dF6Ha_R3M7iPbUS5np09duRf5PpUegfxa_7ynGpIe6b7-qPCmKGB3JUxWEiVAc4pXxVnar7cbu_GfzBvNdHf92P3_hQ2haQ8FnEFW9e8R9CHgM2Y8WmW5NaKsaB2LNo54FBPirxjMFRF8CIMmSuui6HstEWQFOw5jfyRxlW8kURoegqAtmFxvacfeg04ih7Ji2T3YOIq5N47E94oGtLMTIsYckiZSZ-4kAJQu-ka8bekTs4DUOJQBey_M95BJjuARWXCWbWcXDfXlDbB_5lXfnHLaZmOXN0mcJj24sptBtpE3sN05zW1QHlB8X0Fg4-Gz3XirXtWJec5WgLp5Tsw5fZZCVacQZNDxi7x_9SHIwSJ3YUbSDog_v48sgIAEjXOB3h0b8Gts09L2S-oq8moWp2osGCEvmoFIWRd3dfCjUXNYi0jp-uXSW3KJLYhSdso8z1ul7H_bhJ-36mbg8O4op31ezEe8ffDgLrpH9bCFq_LsG4mxUkOl-o8599Hw8wzPsbRRwfdybkDwuMj4jts7N7pGgAS4F-aaT2Lo6NMx2aFmnLQ3z9tCI4SBU0eRn0lbGgqh1hcG1-JmfQw6CFe\" /><input type=\"hidden\"
    //      name=\"TermUrl\"  value=\"https://ipe-ngp.cert.sabre.com/ipe/3DS?merchantReference=01411627286064031810&merchantId=ET\" /><noscript><br/><br/><div style=\"text-align: center\"><h1>Processing your Transaction </h1><p>Please click continue to continue the processing of your transaction.</p><input type=\"submit\" name=\"submit\" value=\"continue\" /></div></noscript></form></body></html>`
    // //   $("#htmlview").css("display","none");
      
    //   localStorage.setItem("summaryDetail", JSON.stringify(n));
    //   window.location.replace("/threed");

      HttpService.postServiceDefualt(
        paymentInformationRequestObject,
        submitApiRelativePath
      ).then(
        (response) => {
          
          // console.log("payment response");
          // console.log(response);

          this.setState({ isLoadingPaymentCredit: false });

          var paymentApiResponse = response.data;
          if (
            paymentApiResponse.statusAPI === "SUCCESS" ||
            paymentApiResponse.statusAPI === "success" ||
            paymentApiResponse.statusAPI === "Success"
          ) {
            this.setState({ PaymentResponseMessage: "SUCCESS" });

            localStorage.setItem(
              "paylocal",
              JSON.stringify(paymentApiResponse)
            );
            localStorage.setItem(
              "summaryDetails",
              JSON.stringify(paymentApiResponse.summary)
            );
            window.location.replace("/payment-summary-details");
          } else if (
            paymentApiResponse.statusAPI == "REDIRECT" ||
            paymentApiResponse.statusAPI == "redirect"
          ) {
            this.setState({ PaymentResponseMessage: "REDIRECTING..." });
            localStorage.setItem("summaryDetail", JSON.stringify(paymentApiResponse.summary.redirectHtml));
            localStorage.setItem("paymentType",  "3d" );
            window.location.replace("/threed");
  
            // window.location.replace(paymentApiResponse.summary.redirectHtml);
          } else if (paymentApiResponse.statusAPI == "WARNING") {
            this.setState({
              PaymentResponseMessage:
                "WARNING: Unable to process payment, Please check the card details you entered and try again…",
            });
          } else {
            if (paymentApiResponse.summary != null) {
              this.setState({
                PaymentResponseMessage:
                  "Unable to proceed with the booking, Please start the booking again!",
              });
            }
            else {
              this.setState({
                PaymentResponseMessage:
                  "Unable to proceed with the booking, Please start the booking again!",
              });
            }
          }
        },
        (error) => {
          this.setState({
            isLoadingPaymentCredit: false,
            PaymentResponseMessage:
              "ERROR: Unable to proceed with the booking, Please start the booking again!",
          });
        }
      );
    }
  }

  render() {
    var {
      validated,
      Years,
      Months,
      FirstName,
      LastName,
      CardType,
      ExpireMonth,
      CVC,
      ResidenceCountry,
      ExpireYear,
      CardNumber,
      initLocalPayment,
    } = this.state;

    const countriesList = [
      { name: "Afghanistan", code: "AF" },
      { name: "Åland Islands", code: "AX" },
      { name: "Albania", code: "AL" },
      { name: "Algeria", code: "DZ" },
      { name: "American Samoa", code: "AS" },
      { name: "AndorrA", code: "AD" },
      { name: "Angola", code: "AO" },
      { name: "Anguilla", code: "AI" },
      { name: "Antarctica", code: "AQ" },
      { name: "Antigua and Barbuda", code: "AG" },
      { name: "Argentina", code: "AR" },
      { name: "Armenia", code: "AM" },
      { name: "Aruba", code: "AW" },
      { name: "Australia", code: "AU" },
      { name: "Austria", code: "AT" },
      { name: "Azerbaijan", code: "AZ" },
      { name: "Bahamas", code: "BS" },
      { name: "Bahrain", code: "BH" },
      { name: "Bangladesh", code: "BD" },
      { name: "Barbados", code: "BB" },
      { name: "Belarus", code: "BY" },
      { name: "Belgium", code: "BE" },
      { name: "Belize", code: "BZ" },
      { name: "Benin", code: "BJ" },
      { name: "Bermuda", code: "BM" },
      { name: "Bhutan", code: "BT" },
      { name: "Bolivia", code: "BO" },
      { name: "Bosnia and Herzegovina", code: "BA" },
      { name: "Botswana", code: "BW" },
      { name: "Bouvet Island", code: "BV" },
      { name: "Brazil", code: "BR" },
      { name: "British Indian Ocean Territory", code: "IO" },
      { name: "Brunei Darussalam", code: "BN" },
      { name: "Bulgaria", code: "BG" },
      { name: "Burkina Faso", code: "BF" },
      { name: "Burundi", code: "BI" },
      { name: "Cambodia", code: "KH" },
      { name: "Cameroon", code: "CM" },
      { name: "Canada", code: "CA" },
      { name: "Cape Verde", code: "CV" },
      { name: "Cayman Islands", code: "KY" },
      { name: "Central African Republic", code: "CF" },
      { name: "Chad", code: "TD" },
      { name: "Chile", code: "CL" },
      { name: "China", code: "CN" },
      { name: "Christmas Island", code: "CX" },
      { name: "Cocos (Keeling) Islands", code: "CC" },
      { name: "Colombia", code: "CO" },
      { name: "Comoros", code: "KM" },
      { name: "Congo", code: "CG" },
      { name: "Congo, The Democratic Republic of the", code: "CD" },
      { name: "Cook Islands", code: "CK" },
      { name: "Costa Rica", code: "CR" },
      { name: "Cote D'Ivoire", code: "CI" },
      { name: "Croatia", code: "HR" },
      { name: "Cuba", code: "CU" },
      { name: "Cyprus", code: "CY" },
      { name: "Czech Republic", code: "CZ" },
      { name: "Denmark", code: "DK" },
      { name: "Djibouti", code: "DJ" },
      { name: "Dominica", code: "DM" },
      { name: "Dominican Republic", code: "DO" },
      { name: "Ecuador", code: "EC" },
      { name: "Egypt", code: "EG" },
      { name: "El Salvador", code: "SV" },
      { name: "Equatorial Guinea", code: "GQ" },
      { name: "Eritrea", code: "ER" },
      { name: "Estonia", code: "EE" },
      { name: "Ethiopia", code: "ET" },
      { name: "Falkland Islands (Malvinas)", code: "FK" },
      { name: "Faroe Islands", code: "FO" },
      { name: "Fiji", code: "FJ" },
      { name: "Finland", code: "FI" },
      { name: "France", code: "FR" },
      { name: "French Guiana", code: "GF" },
      { name: "French Polynesia", code: "PF" },
      { name: "French Southern Territories", code: "TF" },
      { name: "Gabon", code: "GA" },
      { name: "Gambia", code: "GM" },
      { name: "Georgia", code: "GE" },
      { name: "Germany", code: "DE" },
      { name: "Ghana", code: "GH" },
      { name: "Gibraltar", code: "GI" },
      { name: "Greece", code: "GR" },
      { name: "Greenland", code: "GL" },
      { name: "Grenada", code: "GD" },
      { name: "Guadeloupe", code: "GP" },
      { name: "Guam", code: "GU" },
      { name: "Guatemala", code: "GT" },
      { name: "Guernsey", code: "GG" },
      { name: "Guinea", code: "GN" },
      { name: "Guinea-Bissau", code: "GW" },
      { name: "Guyana", code: "GY" },
      { name: "Haiti", code: "HT" },
      { name: "Heard Island and Mcdonald Islands", code: "HM" },
      { name: "Holy See (Vatican City State)", code: "VA" },
      { name: "Honduras", code: "HN" },
      { name: "Hong Kong", code: "HK" },
      { name: "Hungary", code: "HU" },
      { name: "Iceland", code: "IS" },
      { name: "India", code: "IN" },
      { name: "Indonesia", code: "ID" },
      { name: "Iran, Islamic Republic Of", code: "IR" },
      { name: "Iraq", code: "IQ" },
      { name: "Ireland", code: "IE" },
      { name: "Isle of Man", code: "IM" },
      { name: "Israel", code: "IL" },
      { name: "Italy", code: "IT" },
      { name: "Jamaica", code: "JM" },
      { name: "Japan", code: "JP" },
      { name: "Jersey", code: "JE" },
      { name: "Jordan", code: "JO" },
      { name: "Kazakhstan", code: "KZ" },
      { name: "Kenya", code: "KE" },
      { name: "Kiribati", code: "KI" },
      { name: "Korea, Democratic People'S Republic of", code: "KP" },
      { name: "Korea, Republic of", code: "KR" },
      { name: "Kuwait", code: "KW" },
      { name: "Kyrgyzstan", code: "KG" },
      { name: "Lao People'S Democratic Republic", code: "LA" },
      { name: "Latvia", code: "LV" },
      { name: "Lebanon", code: "LB" },
      { name: "Lesotho", code: "LS" },
      { name: "Liberia", code: "LR" },
      { name: "Libyan Arab Jamahiriya", code: "LY" },
      { name: "Liechtenstein", code: "LI" },
      { name: "Lithuania", code: "LT" },
      { name: "Luxembourg", code: "LU" },
      { name: "Macao", code: "MO" },
      { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
      { name: "Madagascar", code: "MG" },
      { name: "Malawi", code: "MW" },
      { name: "Malaysia", code: "MY" },
      { name: "Maldives", code: "MV" },
      { name: "Mali", code: "ML" },
      { name: "Malta", code: "MT" },
      { name: "Marshall Islands", code: "MH" },
      { name: "Martinique", code: "MQ" },
      { name: "Mauritania", code: "MR" },
      { name: "Mauritius", code: "MU" },
      { name: "Mayotte", code: "YT" },
      { name: "Mexico", code: "MX" },
      { name: "Micronesia, Federated States of", code: "FM" },
      { name: "Moldova, Republic of", code: "MD" },
      { name: "Monaco", code: "MC" },
      { name: "Mongolia", code: "MN" },
      { name: "Montserrat", code: "MS" },
      { name: "Morocco", code: "MA" },
      { name: "Mozambique", code: "MZ" },
      { name: "Myanmar", code: "MM" },
      { name: "Namibia", code: "NA" },
      { name: "Nauru", code: "NR" },
      { name: "Nepal", code: "NP" },
      { name: "Netherlands", code: "NL" },
      { name: "Netherlands Antilles", code: "AN" },
      { name: "New Caledonia", code: "NC" },
      { name: "New Zealand", code: "NZ" },
      { name: "Nicaragua", code: "NI" },
      { name: "Niger", code: "NE" },
      { name: "Nigeria", code: "NG" },
      { name: "Niue", code: "NU" },
      { name: "Norfolk Island", code: "NF" },
      { name: "Northern Mariana Islands", code: "MP" },
      { name: "Norway", code: "NO" },
      { name: "Oman", code: "OM" },
      { name: "Pakistan", code: "PK" },
      { name: "Palau", code: "PW" },
      { name: "Palestinian Territory, Occupied", code: "PS" },
      { name: "Panama", code: "PA" },
      { name: "Papua New Guinea", code: "PG" },
      { name: "Paraguay", code: "PY" },
      { name: "Peru", code: "PE" },
      { name: "Philippines", code: "PH" },
      { name: "Pitcairn", code: "PN" },
      { name: "Poland", code: "PL" },
      { name: "Portugal", code: "PT" },
      { name: "Puerto Rico", code: "PR" },
      { name: "Qatar", code: "QA" },
      { name: "Reunion", code: "RE" },
      { name: "Romania", code: "RO" },
      { name: "Russian Federation", code: "RU" },
      { name: "RWANDA", code: "RW" },
      { name: "Saint Helena", code: "SH" },
      { name: "Saint Kitts and Nevis", code: "KN" },
      { name: "Saint Lucia", code: "LC" },
      { name: "Saint Pierre and Miquelon", code: "PM" },
      { name: "Saint Vincent and the Grenadines", code: "VC" },
      { name: "Samoa", code: "WS" },
      { name: "San Marino", code: "SM" },
      { name: "Sao Tome and Principe", code: "ST" },
      { name: "Saudi Arabia", code: "SA" },
      { name: "Senegal", code: "SN" },
      { name: "Serbia and Montenegro", code: "CS" },
      { name: "Seychelles", code: "SC" },
      { name: "Sierra Leone", code: "SL" },
      { name: "Singapore", code: "SG" },
      { name: "Slovakia", code: "SK" },
      { name: "Slovenia", code: "SI" },
      { name: "Solomon Islands", code: "SB" },
      { name: "Somalia", code: "SO" },
      { name: "South Africa", code: "ZA" },
      { name: "South Georgia and the South Sandwich Islands", code: "GS" },
      { name: "Spain", code: "ES" },
      { name: "Sri Lanka", code: "LK" },
      { name: "Sudan", code: "SD" },
      { name: "Suriname", code: "SR" },
      { name: "Svalbard and Jan Mayen", code: "SJ" },
      { name: "Swaziland", code: "SZ" },
      { name: "Sweden", code: "SE" },
      { name: "Switzerland", code: "CH" },
      { name: "Syrian Arab Republic", code: "SY" },
      { name: "Taiwan, Province of China", code: "TW" },
      { name: "Tajikistan", code: "TJ" },
      { name: "Tanzania, United Republic of", code: "TZ" },
      { name: "Thailand", code: "TH" },
      { name: "Timor-Leste", code: "TL" },
      { name: "Togo", code: "TG" },
      { name: "Tokelau", code: "TK" },
      { name: "Tonga", code: "TO" },
      { name: "Trinidad and Tobago", code: "TT" },
      { name: "Tunisia", code: "TN" },
      { name: "Turkey", code: "TR" },
      { name: "Turkmenistan", code: "TM" },
      { name: "Turks and Caicos Islands", code: "TC" },
      { name: "Tuvalu", code: "TV" },
      { name: "Uganda", code: "UG" },
      { name: "Ukraine", code: "UA" },
      { name: "United Arab Emirates", code: "AE" },
      { name: "United Kingdom", code: "GB" },
      { name: "United States", code: "US" },
      { name: "United States Minor Outlying Islands", code: "UM" },
      { name: "Uruguay", code: "UY" },
      { name: "Uzbekistan", code: "UZ" },
      { name: "Vanuatu", code: "VU" },
      { name: "Venezuela", code: "VE" },
      { name: "Viet Nam", code: "VN" },
      { name: "Virgin Islands, British", code: "VG" },
      { name: "Virgin Islands, U.S.", code: "VI" },
      { name: "Wallis and Futuna", code: "WF" },
      { name: "Western Sahara", code: "EH" },
      { name: "Yemen", code: "YE" },
      { name: "Zambia", code: "ZM" },
      { name: "Zimbabwe", code: "ZW" },
    ];
    return (
      <div>
        <Form
          noValidate
          validated={validated}
          onSubmit={this.handleSubmit}
          className=" shadow pl-2 pr-2 pb-3  pt-2 mb-5 bg-white rounded"
        >
          <Form.Row>
            {this.state.PaymentResponseMessage && (
              <strong className="pt-0 float-left " style={{ color: "red" }}>
                {this.state.PaymentResponseMessage}
              </strong>
            )} 
          </Form.Row>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 mb-2">
              <div className="list-group text-left">
                <ul className="social-media p-0" style={{"list-style-type": "none"}}>
                  <li > 
                    <img
                      className="payment-image"
                      src={
                        window.location.origin +
                        "/assets/image/payment/master card.png"
                      }
                    />
                    <img
                      className="payment-image"
                      src={
                        window.location.origin +
                        "/assets/image/payment/visa.jpg"
                      }
                    />
                    <img
                      className="payment-image"
                      src={
                        window.location.origin +
                        "/assets/image/payment/American Express.png"
                      }
                    />
                    <img
                      className="payment-image"
                      src={
                        window.location.origin +
                        "/assets/image/payment/dinners.jpg"
                      }
                    /> 
                  </li>
                </ul>
              </div>
            </div>
            <hr style={{ color: "white", height: "3px" }} />
          </div>
      


          <Form.Row>
            <h4 className="pt-0 float-left">Credit Card Information</h4>
          </Form.Row>
          {/* <br /> */}


          
          <Form.Row> 
             {!this.state.isFormValid &&
                                <Alert variant="danger" style={{width: "100%", textAlign: "initial"}}>
                                    {"Please provide all required information with symbol(*) correctly"}

                                </Alert>
                           }
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="6" controlId="FirstName">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependFirstName">
                    <FontAwesomeIcon className="pr-2" icon={faUser} size="lg" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  required
                  minLength="2"
                  aria-describedby="inputGroupPrependFirstName"
                  type="text"
                  placeholder="Card Holder First name*"
                  defaultValue=""
                  value={this.state.FirstName}
                  onChange={(e) => this.setState({ FirstName: e.target.value })}
                />
                {/* <Form.Control.Feedback type="invalid">
                  Please input a valid First Name
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
            <Form.Group as={Col} md="6" controlId="LastName">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependLastName">
                    <FontAwesomeIcon className="pr-2" icon={faUser} size="lg" />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  required
                  minLength="2"
                  type="text"
                  placeholder="Card Holder Last name*"
                  aria-describedby="inputGroupPrependLastName"
                  defaultValue=""
                  value={this.state.LastName}
                  onChange={(e) => this.setState({ LastName: e.target.value })}
                />

                {/* <Form.Control.Feedback type="invalid">
                  Please input a valid Last Name
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="CardType">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependCardType">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faCreditCard}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  defaultValue=""
                  value={this.state.CardType}
                  required
                  aria-describedby="inputGroupPrependCardType"
                  onChange={(e) => this.setState({ CardType: e.target.value })}
                  onSelect={(value) => this.setState({ CardType: value })}
                >
                  <option value="" selected>
                    Select Card Type*
                  </option>
                  <option value="VI">Visa</option>
                  <option value="CA">Master card</option>
                  <option value="AX">American express</option>
                  <option value="DC">Diners club</option>
                </Form.Control>
                {/* <Form.Control.Feedback type="invalid">
                  Please input a valid Card Type
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="CardNumber">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependCardNumber">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faCreditCard}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="number"
                  minLength="2"
                  placeholder="Card Number*"
                  aria-describedby="inputGroupPrependCardNumber"
                  required
                  min="0"
                  value={this.state.CardNumber}
                  onChange={(e) =>
                    this.setState({ CardNumber: e.target.value })
                  }
                />
                {/* <Form.Control.Feedback type="invalid">
                  Please input a valid CardNumber.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="CVC">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependCVC">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faCreditCard}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="number"
                  minLength="2"
                  min="0"
                  placeholder="CVC*"
                  aria-describedby="inputGroupPrependCVC"
                  required
                  value={this.state.CVC}
                  onChange={(e) => this.setState({ CVC: e.target.value })}
                />
                {/* <Form.Control.Feedback type="invalid">
                  Please Insert a valid CVC.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="4" controlId="ExpireMonth">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependExpireMonth">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faClock}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  defaultValue=""
                  value={this.state.ExpireMonth}
                  required
                  aria-describedby="inputGroupPrependExpireMonth"
                  onChange={(e) =>
                    this.setState({ ExpireMonth: e.target.value })
                  }
                  onSelect={(value) => this.setState({ ExpireMonth: value })}
                >
                  <option value="" selected>
                    Select Expire Month*
                  </option>
                  {Months.map((month) => (
                    <option value={month.code}>{month.name}</option>
                  ))}
                </Form.Control>
                {/* <Form.Control.Feedback type="invalid">
                  Please provide a valid Expire Month.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="ExpireYear">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependExpireYear">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faClock}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  defaultValue=""
                  value={this.state.ExpireYear}
                  required
                  aria-describedby="inputGroupPrependExpireYear"
                  onChange={(e) =>
                    this.setState({ ExpireYear: e.target.value })
                  }
                  onSelect={(value) => this.setState({ ExpireYear: value })}
                >
                  <option value="" selected>
                    Select Expire Year*
                  </option>
                  {Years.map((year) => (
                    <option value={year}>{year}</option>
                  ))}
                </Form.Control>
                {/* <Form.Control.Feedback type="invalid">
                  Please provide a valid Expire Year.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="ResidenceCountry">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependResidenceCountry">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faMapSigns}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as="select"
                  defaultValue=""
                  required
                  aria-describedby="inputGroupPrependResidenceCountry"
                  value={this.state.ResidenceCountry}
                  onChange={(e) =>
                    this.setState({ ResidenceCountry: e.target.value })
                  }
                  onSelect={(value) =>
                    this.setState({ ResidenceCountry: value })
                  }
                >
                  <option value="">Select Residence Country*</option>
                  {countriesList.map((country) => (
                    <option value={country.code}>{country.name}</option>
                  ))}
                </Form.Control>
                {/* <Form.Control.Feedback type="invalid">
                  Please provide a valid Residence Country.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} md="4" controlId="PostalCode">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependPostalCode">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faLocationArrow}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Postal Code*"
                  required
                  minLength="2"
                  aria-describedby="inputGroupPrependPostalCode"
                  value={this.state.PostalCode}
                  onChange={(e) =>
                    this.setState({ PostalCode: e.target.value })
                  }
                />
                {/* <Form.Control.Feedback type="invalid">
                  Please provide a Postal Code.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="BillingAddress">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependBillingAddress">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faLocationArrow}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Billing Address*"
                  required
                  aria-describedby="inputGroupPrependBillingAddress"
                  value={this.state.BillingAddress}
                  onChange={(e) =>
                    this.setState({ BillingAddress: e.target.value })
                  }
                />
                {/* <Form.Control.Feedback type="invalid">
                  Please provide a valid Input.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="AddressTwo">
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroupPrependAddressTwo">
                    <FontAwesomeIcon
                      className="pr-2"
                      icon={faMapSigns}
                      size="lg"
                    />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  required={false}
                  aria-describedby="inputGroupPrependAddressTwo"
                  placeholder="Address Two(optional)"
                  aria-describedby="inputGroupPrependCVC"
                  value={this.state.AddressTwo}
                  onChange={(e) =>
                    this.setState({ AddressTwo: e.target.value })
                  }
                />
              </InputGroup>
            </Form.Group>
          </Form.Row>

          <Row className="pl-5">
            <Col style={{ textAlign: "left" }} sm={12}>
            {this.state.agreeTermsCommand &&
                    <Alert variant="danger">
                      Please agree the terms and condition to make payment.

                    </Alert>
             }  
              </Col>
            <Col style={{ textAlign: "left" }} sm={12}>
              <input
                class="form-check-input"
                type="checkbox"
                onChange={(value) =>
                  this.setState({agreeTermsCommand:false,
                    agreeTermsCredit: document.getElementById(
                      "defaultCheckCredit"
                    ).checked,
                  })
                }
                id="defaultCheckCredit"
              />
              <label className="form-check-label" for="defaultCheckCredit">
                I agree to the{" "}
              </label>
              <Card.Link
                onClick={() => this.setState({ showModal: true })}
                style={{ color: "green", cursor: "pointer" }}
              >
                {" "}
                Terms and Condition{" "}
              </Card.Link>
            </Col>
            <Col style={{ textAlign: "left" }} sm={12} className="mt-2">
              {this.state.isLoadingPaymentCredit && (
                <Button variant="success" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Making Payment...
                </Button>
              )}

              {this.state.isLoadingPaymentCredit === false && (
                <>
                  {this.state.agreeTermsCredit === true && (
                    <Button
                      type="submit"
                      class="btn btn-success btn-sm"
                      variant="success"
                    >
                      <strong>Pay Now</strong>
                    </Button>
                  )}
                  {this.state.agreeTermsCredit === false && (
                    <Button
                      // type="submit"
                      class="btn btn-success btn-sm"
                      variant="success"
                      onClick={()=>{  this.setState({agreeTermsCommand:true})}}
                    >
                      <strong>Pay Now</strong>
                    </Button>
                  )}
                </>
              )}
            </Col>
          </Row>
        </Form>
        {this.state.isLoadingPaymentCredit && (
          <ProgressLoader displayMess="Processing Payment"></ProgressLoader>
        )}

        <Modal
          scrollable={true}
          size="lg"
          aria-labelledby="example-custom-modal-styling-title"
          show={this.state.showModal}
          onHide={() => this.setState({ showModal: false })}
        >
          <Modal.Header closeButton className="p-1 pl-3 pt-0">
            <Modal.Title>Terms and Condition</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <TermsAndCondition></TermsAndCondition>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default CreditCardForm;
